<div class="pcce-form-container container-fluid">
  <ziro-fieldset-header [legend]="'tkey;pages.details.agentSettings.header'">
    <ziro-text fieldId="userName"></ziro-text>
    <ziro-checkbox fieldId="ssoEnabled"></ziro-checkbox>
    <ziro-text fieldId="password"></ziro-text>
    <ziro-text fieldId="confirmPassword"></ziro-text>
    <ziro-text fieldId="description"></ziro-text>
    <ziro-select fieldId="department"></ziro-select>
    <ziro-select fieldId="agentTeam"></ziro-select>
    <ziro-select fieldId="agentDeskSettings"></ziro-select>
    <ziro-select fieldId="skillGroups"></ziro-select>
  </ziro-fieldset-header>

  <legend>{{ 'tkey;pcce.attributes.title' | translate }}</legend>

  <ziro-navset data-automation="attributes-navset" fieldId="pcceNavset"></ziro-navset>
</div>
